/**
 * Home Credit (https://www.homecredit.vn/)
 *
 * Copyright © 2018-present HomeCredit, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */
import { Input, NumberInput } from 'homecredit-ui';
import DuplicatedOutTime from './DuplicatedOutTime';
import chuho from './images/chuho.png';
import chuhoWeb from './images/chuho.web';
import giaypheplaixe from './images/giaypheplaixe.png';
import giaypheplaixeWeb from './images/giaypheplaixe.web';
import sohokhau from './images/sohokhau.png';
import sohokhauWeb from './images/sohokhau.web';
import OTP from './OTP';
import PersonalInformation from './PersonalInformation';
import StartLoan from './StartLoan';
import WaitingDuplicated from './WaitingDuplicated';
import AdditionalUserDocument from './AdditionalUserDocument';
import NewUserWaiting from './NewUserWaiting';
import NoOffer from './NoOffer';
import NewUserRejectOffer from './NewUserRejectOffer';
import WaitingPage from './WaitingPage';
import LoanCalculator from './LoanCalculator';
import NoSACode from './NoSACode';

export const TITLE_BOD = 'Vay tiền nhanh - Home Credit';
export const DESCRIPTION_BOD =
  'Vay tiền nhanh online từ Home Credit với thủ tục đơn giản, giải ngân ngay, lãi suất hấp dẫn, không cần thế chấp tài sản.';
export const TIME_RECAL_API = 30000;
export const TIME_WAITING = 180000;

export const lang = {
  vi: 'vi-VN',
  en: 'en-US',
  cs: 'cs-CZ',
};

export const genders = {
  MALE: 'Anh',
  FEMALE: 'Chị',
};

// ------ GA --------

export const GA = {
  CHECK_USER: {
    CATEGORY: 'CheckExistUser',
    LABEL: {
      ID_CARD: 'Personal_ID',
      DOB: 'DOB',
    },
    ACTION: {
      ID_CARD: 'Input_personal_ID',
      DOB: 'Select_DOB',
    },
  },
  DOCUMENT: {
    BANK_STATMENT_3: {
      action: 'Tap_Bank_Statement_Option',
      label: 'Bank_Statement_Option',
    },
    LAB_CONTRACT: {
      action: 'Tap_Employment_Contract_Option',
      label: 'Employment_Contract_Option',
    },
    PAY_SLIP_ANY: {
      action: 'Tap_Payslip_Option',
      label: 'Payslip_Option',
    },
    BILL_ANY: {
      action: 'Tap_Electricity_Bill_Option',
      label: 'Electricity_Bill_Option',
    },
  },
};

// ------ FIRST BOD ------

export const REGEX = {
  NONE_SPACE: /^\S+$/,
  NONE_SPECIAL_CHARACTER: /[^a-zA-Z0-9]/,
};

export const STEPS = {
  START_LOAN: 0,
  PERSONAL_INFORMATION: 1,
  OTP: 2,
  WAITING: 3,
  DEDUP_WAITING: 4,
  DEDUP_WAITING_OUT_TIME: 5,
  NEW_CUSTOMER_DOCS: 6,
  NEW_USER_WAITING: 7,
  NO_OFFER: 8,
  NEW_USER_NO_OFFER: 9,
  NEW_USER_LOAN_CALCULATE: 10,
  NO_SA_CODE: 11,
};

export const STEP_NAME = {
  [STEPS.START_LOAN]: 'bat-dau-vay-moi',
  [STEPS.PERSONAL_INFORMATION]: 'nhap-thong-tin-vay',
  [STEPS.OTP]: 'xac-thuc-vay',
  [STEPS.WAITING]: 'dang-tim-goi-vay',
  [STEPS.DEDUP_WAITING]: 'dang-xac-nhan-thong-tin-vay',
  [STEPS.DEDUP_WAITING_OUT_TIME]: 'xac-nhan-thong-tin-vay-ngoai-gio',
  [STEPS.NEW_CUSTOMER_DOCS]: 'dang-xac-nhan-thong-tin-vay-moi',
  [STEPS.NEW_USER_WAITING]: 'dang-xu-ly-thong-tin-vay-moi',
  [STEPS.NO_OFFER]: 'khong-thay-goi-vay',
  [STEPS.NEW_USER_NO_OFFER]: 'tu-choi-khoan-vay',
  [STEPS.NEW_USER_LOAN_CALCULATE]: 'tinh-toan-khoan-vay',
  [STEPS.NO_SA_CODE]: 'no-sa-code',
  SUBMIT_APPLICATION_WAITING: 'dang-tim-khoan-vay',
  SUBMIT_APPLICATION_SUCCESS: 'duyet-vay-thanh-cong',
  SUBMIT_APPLICATION_FAILED: 'khong-co-khoan-vay-phu-hop',
  SUBMIT_APPLICATION_REJECTED: 'khoan-vay-bi-tu-choi',
  USER_HAS_OFFER: 'danh-sach-goi-vay',
  NEW_USER_HAS_OFFER: 'da-tim-thay-khoan-vay-moi',
};

export const UNIFIED_ID_TYPE = {
  familyBook: 'drivingLicence',
  drivingLicence: 'familyBook',
};

export const HEADER_TITLES = {
  [STEPS.PERSONAL_INFORMATION]: 'Hãy chọn nhu cầu vay của bạn!',
};

export const STEP_COMPONENT = {
  [STEPS.START_LOAN]: StartLoan,
  [STEPS.PERSONAL_INFORMATION]: PersonalInformation,
  [STEPS.OTP]: OTP,
  [STEPS.WAITING]: WaitingPage,
  [STEPS.DEDUP_WAITING]: WaitingDuplicated,
  [STEPS.DEDUP_WAITING_OUT_TIME]: DuplicatedOutTime,
  [STEPS.NEW_CUSTOMER_DOCS]: AdditionalUserDocument,
  [STEPS.NEW_USER_WAITING]: NewUserWaiting,
  [STEPS.NO_OFFER]: NoOffer,
  [STEPS.NEW_USER_NO_OFFER]: NewUserRejectOffer,
  [STEPS.NEW_USER_LOAN_CALCULATE]: LoanCalculator,
  [STEPS.NO_SA_CODE]: NoSACode,
};

export const GENDER = {
  MALE: 'Nam',
  FEMALE: 'Nữ',
};

export const NEXT_TEXT = 'Tiếp tục';

// ----- INPUT PHONE ------
export const INPUT_PHONE_FIELDS = {
  label: 'Nhập số điện thoại liên lạc',
  name: 'phoneNumber',
  type: 'tel',
};
export const INPUT_PHONE_TEXTS = {
  TITLE: 'Mã xác thực (OTP) sẽ được gửi đến số điện thoại này',
};

// ----- SA_CODE ------
export const SA_CODE_INPUT = {
  label: 'Mã giới thiệu',
  name: 'retailAgent',
  type: 'text',
};

// ----- OTP ------
export const OTP_TEXTS = {
  TERM: 'Bằng cách tiếp tục, tôi đã đồng ý những ',
  CONDITION: 'điều khoản và điều kiện',
  AGREE: 'Tôi đã hiểu',
  DESCRIPTION: 'Vui lòng nhập Mã Xác Thực được gửi đến số điện thoại ',
  MAXIMUM_TRIED_1: 'Bạn đã dùng hết số lần gửi Mã Xác Thực.',
  MAXIMUM_TRIED_2: 'Vui lòng nhập lại số điện thoại liên lạc để xác thực.',
  ATTEMP_1: 'Mã Xác Thực vừa nhập không đúng',
  ATTEMP_2: 'Xin vui lòng nhập lại. Bạn còn ',
  ATTEMP_3: ' lần nhập.',
  MAXIMUM_ATTEMP_1: 'Bạn vừa nhập sai Mã Xác Thực quá ',
  MAXIMUM_ATTEMP_2: ' lần.',
  MAXIMUM_ATTEMP_3: 'Vui lòng nhập lại số điện thoại liên lạc để xác thực.',
  OTP_DISABLED:
    'Mã Xác Thực đã hết hạn. Vui lòng nhấn "Gửi lại Mã Xác Thực" đế lấy Mã Xác Thực mới',
  TERM_CONDITION:
    'Tôi đồng ý cho phép Home Credit thu nhập, sử dụng cũng như chia sẻ với bên thứ ba các thông tin liên quan đến tôi và/ hoặc liên quan đến các khoản vay của tôi.',
};
export const INPUT_OTP_FIELDS = {
  label: 'Nhập Mã Xác Thực',
  name: 'otp',
  type: 'tel',
};
export const ACCEPTED_TERM_FIELDS = {
  label: 'Bằng cách tiếp tục, tôi đồng ý những ',
  name: 'acceptedTerm',
};
export const MAX_ATTEMPT = 3;
export const MAX_RETRY = 3;
export const OTP_COUNT_SECOND = 300;

// ----- CALCULATE CASH ------
export const CREDIT_AMOUNT_FIELDS = {
  label: 'Số tiền vay',
  name: 'creditAmount',
  type: 'number',
};
export const TENOR_FIELDS = {
  label: 'Thời gian vay',
  name: 'tenor',
  type: 'number',
};
export const CREDIT_AMOUNT_MIN = 10;
export const CREDIT_AMOUNT_MAX = 30;
export const CREDIT_AMOUNT_STEP = 5;
export const TENOR_MIN = 12;
export const TENOR_MAX = 48;

export const TENOR_BUTTONS = [
  { value: 12, content: '12' },
  { value: 18, content: '18' },
  { value: 24, content: '24' },
  { value: 36, content: '36' },
  { value: 48, content: '48' },
];

// ----- USER INFO ------
export const USER_INFO_TEXTS = {
  NOTE: 'Vui lòng điền đầy đủ dấu và các thông tin bắt buộc (*)',
  BIRTHDAY_POPUP_1: 'Vui lòng nhập ngày 01 nếu chỉ có tháng & năm sinh.',
  BIRTHDAY_POPUP_2: 'Vui lòng nhập ngày 01, tháng 01 nếu chỉ có năm sinh.',
};

// ----- USER INCOME ------
export const POPUP_TYPE = {
  DL: 'Giấy phép lái xe',
  FRB: 'Sổ hộ khẩu',
};

export const POPUP_CONTENT = {
  [POPUP_TYPE.DL]: [
    {
      step: 1,
      picture: [
        { srcSet: giaypheplaixeWeb, type: 'image/webp' },
        { srcSet: giaypheplaixe, type: 'image/png' },
      ],
      defaultPic: giaypheplaixe,
      content: 'Vui lòng nhập tất cả ký tự bao gồm ',
      contentBold: 'chữ và số ',
      contentNext: 'trên giấy phép lái xe',
    },
  ],
  [POPUP_TYPE.FRB]: [
    {
      step: 1,
      title: 'Sổ hộ khẩu cũ (số CMND của chủ hộ nằm trên trang Chủ hộ)',
      picture: [
        { srcSet: chuhoWeb, type: 'image/webp' },
        { srcSet: chuho, type: 'image/png' },
      ],
      defaultPic: chuho,
      content:
        'Vui lòng nhập số CMND của chủ hộ (hoặc số CMND của người tiếp theo trong sổ hộ khẩu nếu Chủ hộ không có số CMND)',
    },
    {
      step: 2,
      title: 'Sổ hộ khẩu mới (trang Chủ Hộ không có thông tin CMND của chủ hộ)',
      picture: [
        { srcSet: sohokhauWeb, type: 'image/webp' },
        { srcSet: sohokhau, type: 'image/png' },
      ],
      defaultPic: sohokhau,
      content: 'Vui lòng nhập số Sổ hộ khẩu trên trang đầu tiên của Sổ hộ khẩu',
    },
  ],
};

export const USER_INCOME_FIELDS = [
  {
    label: 'Khoản thu nhập hàng tháng (VNĐ)',
    name: 'monthlyIncome',
    thousandSeparator: '.',
    decimalSeperator: false,
    maxLength: 9,
    component: NumberInput,
    require: true,
    trackingLabel: 'Monthly_income',
    trackingAction: 'Input_monthly_income',
    type: 'tel',
    className: 'col-12',
    msgPosition: 'below',
  },
  {
    label: 'Khoản trả góp hàng tháng khác (VNĐ)',
    name: 'monthlyPayment',
    thousandSeparator: '.',
    decimalSeperator: false,
    maxLength: 9,
    component: NumberInput,
    trackingLabel: 'Other_monthly_installment',
    trackingAction: 'Input_other_monthly_installment',
    type: 'tel',
    className: 'col-12',
    msgPosition: 'below',
  },
  {
    label: 'Số CMND/ Căn cước công dân',
    name: 'idCard',
    decimalSeperator: false,
    maxLength: 12,
    component: Input,
    require: true,
    trackingLabel: 'Personal_ID',
    trackingAction: 'Input_personal_ID',
    className: 'col-12',
    msgPosition: 'below',
  },
];

// ----- SUMMARY ------
export const SUMMARY_TEXTS = {
  INSURANCE_AMOUNT: 'Phí bảo hiểm',
  MONTHTLY_FEE: 'Số tiền trả góp hàng tháng',
  FULL_NAME: 'Họ và tên',
  GENDER: 'Giới tính',
  DATEOFBIRTH: 'Ngày tháng năm sinh',
  ID_CARD: 'Số CMND/ Căn cước công dân',
  AGREE: 'Tôi đã hiểu',
  DECLINED: 'Tôi không muốn đăng ký Gói An Tâm Tài Chính',
  ADD_INSURANCE: 'Tôi muốn đăng ký Gói An Tâm Tài Chính',
  INSURANCE_TITLE: 'Lợi ích của Gói An Tâm Tài Chính',
  INSURANCE_CONTENT_1: '1. Giúp hồ sơ vay dễ được phê duyệt.',
  INSURANCE_CONTENT_2:
    '2. Hỗ trợ chi trả khoản vay khi xảy ra các rủi ro không mong muốn như tai nạn dẫn đến mất khả năng lao động hoặc tử vong.',
  INSURANCE_CONTENT_3: '3. Bồi thường lên đến 250% giá trị khoản vay.',
  SA_POPUP_TITLE: 'Lưu ý',
  SA_POPUP_1:
    'Thông tin không hợp lệ có thể ảnh hưởng đến việc đăng ký đơn vay',
  SA_POPUP_2:
    'Vui lòng chỉ nhập thông tin này nếu bạn là nhân viên Home Credit hoặc được nhân viên Home Credit hướng dẫn',
  SA_CANCEL_BTN: 'Bỏ qua',
  SA_ACCEPT_BTN: 'Nhập thông tin',
};

// ----- CONGRATULATION ------

export const CONGRATS = {
  TITLE: 'Vay tiền mặt',
  SUMMARY:
    'Yêu cầu vay của bạn đã được đăng ký thành công. Chúng tôi sẽ thông báo kết quả đến bạn trong 15 phút tới',
};

// ----- MODALS ------

export const SUBMIT_APPLICATION_FAIL = 'SUBMIT_APPLICATION_FAIL';
export const AGREE = 'Tôi đã hiểu';
export const INVALID_SA_CODE = 'INVALID_SA_CODE';
export const INVALID_TOKEN_CODE = 'INVALID_TOKEN';
export const EMPTY_OFFER = 'EMPTY_OFFER';
export const ACL0BOD_HOTLINE = '1800 6860';

export const REDIRECT_HC_CASH_LOAN_PARAMS = [
  'bat-dau-vay',
  'vay-nhanh-uy-tin',
  'vay-truc-tuyen',
  'duyet-vay-trong-90s',
];
